export const updatesConfig = [
  {
    title: 'Добавлены новые возможности настройки интерфейса',
    date: '15.05.2025',
    video: 'interface_settings_demo_720.mp4',
    list: [
      {
        text: 'изменение ширины таблицы'
      },
      {
        text: 'изменение ширины каждого столбца в таблице'
      }
    ]
  },
  {
    title: 'Отличные новости!',
    date: '04.03.2025',
    image: 'skolkovo_resident.jpg',
    descriptions: [
      {
        text: 'Друзья, рады сообщить, что сегодня Soilbox официально стал резидентом «Сколково» в инновационном кластере «Энерготех»!'
      },
      {
        text: 'Это было непростое приключение, которое нам предстояло пройти в сжатые сроки, но мы справились!'
      },
      {
        text: 'Двигаемся вперёд, развиваем технологии и делаем инженерные изыскания ещё эффективнее и привлекательнее! Большая благодарность всем, кто поддерживает нас на этом пути!'
      }
    ]
  },
  {
    title: 'Фильтр зон МСК на карте',
    date: '03.02.2025',
    image: 'wgsmsk_map_filters.png',
    list: [
      {
        text: 'Появилась возможность фильтрации зон по широте на карте.'
      }
    ]
  },
  {
    date: '21.08.2024',
    component: 'python-course'
  },
  {
    title:
      'Рады представить новый функционал, разработанный по вашим просьбам. На сервис добавлено:',
    date: '15.04.2024',
    image: 'updates-image.png',
    list: [
      {
        text: 'Обратный <span>пересчет из MSK в WGS</span>. Зоны необходимо выбирать вручную. Используйте <span>инструмент протягивания ячейки</span> (как в Excel) с выбранной зоной для быстрого заполнения данных в столбце “Зона”.'
      },
      {
        text: '<span>Экспорт данных в DXF</span>, в режиме блоков или изолированных слоев для Autocad и Nanocad. Система координат – МСК.'
      },
      {
        text: '<span>Экспорт данных в KML/KMZ</span> для интеграции с ГИС. Система координат – WGS-84.'
      },
      {
        text: '<span>Экспорт данных в GPX</span> для использования в приемниках Garmin. Система координат – WGS-84.'
      }
    ]
  }
]
